import { notifyError } from "@/utils/monitoring";
import { authorizedPost } from "@/utils/request";

const API_PATH = "/v1/rewards/claim";

export const submitQuestCompletion = async (
  eventId: string,
  getAccessToken: () => Promise<string | undefined>,
): Promise<Error | undefined> => {
  try {
    // Required to ensure that the access token contains the zk address
    const accessToken = await getAccessToken();
    if (accessToken === undefined) {
      throw new Error("Unauthorized");
    }

    await authorizedPost(API_PATH, { event: eventId }, accessToken);
    return undefined;
  } catch (e) {
    notifyError(e, "questCompletionError", { event: eventId });
    return e as Error;
  }
};
